import type { OrderItem } from "./types.ts";

/** Die sichtbare Bezeichnung einer Bestellposition in Dokumentenansichten. */
export function positionsbezeichnung(position: OrderItem, index: number): string {
  const name = typeof position.name === "string" && position.name.trim() ? position.name : "Ohne Artikelbezeichnung";
  return `Position ${index + 1} · ${name}`;
}

/** Liest die persistierte positive JTL-Positionskennung aus den beiden DTO-Formen. */
export function positionskennung(position: OrderItem): number | null {
  const werte = position as Record<string, unknown>;
  const jtlPosId = Number(werte["jtlPosId"] ?? werte["kLieferantenBestellungPos"]);
  return Number.isInteger(jtlPosId) && jtlPosId > 0 ? jtlPosId : null;
}

/** Der getrimmte Text, wenn `wert` ein Text mit Inhalt ist; sonst `null`. */
export const nichtLeer = (wert: unknown): string | null => (typeof wert === "string" && wert.trim() ? wert.trim() : null);

/**
 * Die Position eines entfernten Positionsdokuments (Artwork, Produktionsbild) in „Entfernte Dokumente“ (Ticket F).
 * `jtlPosId` ist die JTL-Positions-Id (kLieferantenBestellungPos), NICHT die laufende Nummer: „Pos. N“ ist der Platz der
 * Position in den Positionen der Bestellung, wie das Positionen-Grid sie zaehlt, dahinter die Artikelnummer - die des
 * Eintrags (der Server liest sie beim Laden der Liste aus `order_jtl_watch`, keine Momentaufnahme vom Entfernen), sonst
 * die der Position.
 *
 * Ist die Position nicht mehr in der Bestellung (inzwischen geloescht), bleibt die Artikelnummer („Artikel X“), sonst die
 * JTL-Id („JTL-Position N“). `null` fuer ein Dokument ohne Position (Bestelldokument).
 */
export function entferntesDokumentPosition(
  positionen: readonly OrderItem[],
  jtlPosId: number | null | undefined,
  artikelNummer: string | null | undefined,
): string | null {
  if (jtlPosId === null || jtlPosId === undefined) return null;
  const index = positionen.findIndex((position) => positionskennung(position) === jtlPosId);
  const artikel = nichtLeer(artikelNummer);
  if (index < 0) return artikel ? `Artikel ${artikel}` : `JTL-Position ${jtlPosId}`;
  const sku = artikel ?? nichtLeer(positionen[index]!.sku);
  return sku ? `Pos. ${index + 1} (${sku})` : `Pos. ${index + 1}`;
}
